'use strict';

const pagination = require('./pagination');
let focusedElementId;

/**
* Stores the ID of the currently focused element in the document.
* If the focused element has an ID, it assigns it to the global variable `focusedElementId`.
* If the focused element does not have an ID, `focusedElementId` is set to null.
*/
function storeFocusedElement() {
    const $focusedElement = document.activeElement;

    if ($focusedElement) {
        focusedElementId = $focusedElement.id || null;
    }
}

/**
* Restores focus to a previously focused HTML element, if it exists.
*
* This function checks if there is a stored `focusedElementId` and attempts to
* retrieve the corresponding DOM element using `document.getElementById`. If
* the element is found, it sets focus back to this element.
*
* @global
* @returns {void} This function does not return a value.
*/
function restoreFocus() {
    if (focusedElementId) {
        var $elementToFocus = document.getElementById(focusedElementId);

        if ($elementToFocus) {
            $elementToFocus.focus();
        }
    }
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function getKeyFromValue(url, value) {
	const searchParams = new URLSearchParams(url.split('?')[1]);
	for (const [key, val] of searchParams.entries()) {
		if (val === value) {
			var keyArr = key.split('');
			return keyArr[keyArr.length - 1];
		}
	}
	return null; // If value is not found
}

/**
 * Execute the ajax request that does the custom slider search
 * @param {Object} customSlider - jQuery DOM element
 * @param {Integer} pmin Min value for the search
 * @param {Integer} pmax Max value for the search
 */
function priceSearch(customSlider, pmin, pmax) {
	var refUrl = customSlider.closest('.js-attribute-slider').data('refurl');

	if (refUrl) {
		var refID = customSlider.closest('.js-attribute-slider').data('refid');
		var keyNum = getKeyFromValue(refUrl, refID);
		var actionUrl = new URL(refUrl, document.location.origin);

		actionUrl.searchParams.set('prefmin' + keyNum, pmin);
		actionUrl.searchParams.set('prefmax' + keyNum, pmax);

		refUrl = actionUrl.toString();
	}

	$.spinner().start();

	let refUrlWithPagination = pagination.getUrlWithPagination(refUrl);
    storeFocusedElement();

	$.ajax({
		url: refUrlWithPagination.href,
		data: {
			template: $('input[name="fallbackTemplate"]').val(),
			filterUsed: true
		},
		method: 'GET',
		success: function (data) {
			$('.container.search-results').html(data);
			$('body').trigger('search:filter');

			pagination.addQueryToBrowserHistory(refUrlWithPagination, 'applyFilter');

			$.spinner().stop();
			$('.refinement-bar, .modal-background').hide();
            restoreFocus();
		},
		error: function () {
			$.spinner().stop();
			$('.refinement-bar, .modal-background').hide();
		}
	});
}

/**
 * Trigger the 'search:beforeFilter' event if the refinement is not in its default active state
 * @param {jQuery} $element The jQuery element that triggered the event
 */
function changeRefinementState($element) {
    const $changedRefinement = $element.closest('.refinement').find('.js-custom-refinement-btn');

    if (!$changedRefinement.hasClass('default-active')) {
        const refinementID = $changedRefinement.data('target').replace('#refinement-', '');
        $('body').trigger('search:beforeFilter', { changedRefinementID: refinementID, isExpanded: true });
    }
}

module.exports = function () {
	$('#maincontent').on('input', '.lowerCustomRange, .upperCustomRange', function () {
		var $lowerInput = $(this).closest('.js-attribute-slider').find('.lowerCustomInput');
		var $upperInput = $(this).closest('.js-attribute-slider').find('.upperCustomInput');
		var $lowerRange = $(this).closest('.js-attribute-slider').find('.lowerCustomRange');
		var $upperRange = $(this).closest('.js-attribute-slider').find('.upperCustomRange');

		var lowerVal = parseInt($lowerRange.val(), 10);
		var upperVal = parseInt($upperRange.val(), 10);

		if (upperVal < lowerVal + 15) {
			$lowerRange.val(upperVal - 15);

			if (lowerVal === $lowerRange.min) {
				$upperRange.value = 15;
			}
		}

		if (lowerVal > upperVal - 15) {
			$upperRange.val(lowerVal + 15);

			if (upperVal === $upperRange.max) {
				$lowerRange.value = parseInt($upperRange.max, 10) - 15;
			}
		}

		$upperInput.val(upperVal);
		$lowerInput.val(lowerVal);
	});

	$('#maincontent').on('change', '.lowerCustomRange, .upperCustomRange', function () {
		var $lowerRange = $(this).closest('.js-attribute-slider').find('.lowerCustomRange');
		var $upperRange = $(this).closest('.js-attribute-slider').find('.upperCustomRange');

        changeRefinementState($(this));

		priceSearch($(this), parseInt($lowerRange.val(), 10), parseInt($upperRange.val(), 10));
	});

	$('#maincontent').on('change', '.lowerCustomInput, .upperCustomInput', function () {
		var $lowerInput = $(this).closest('.js-attribute-slider').find('.lowerCustomInput');
		var $upperInput = $(this).closest('.js-attribute-slider').find('.upperCustomInput');
		var $lowerRange = $(this).closest('.js-attribute-slider').find('.lowerCustomRange');
		var $upperRange = $(this).closest('.js-attribute-slider').find('.upperCustomRange');
		var lowerInputVal = parseInt($lowerInput.val(), 10);
		var upperInputVal = parseInt($upperInput.val(), 10);
		if (Number.isNaN(lowerInputVal) || (lowerInputVal < parseInt($lowerRange.attr('min'), 10)) || (lowerInputVal > parseInt($upperRange.attr('max'), 10))) {
			lowerInputVal = parseInt($lowerRange.attr('min'), 10);
		}
		if (Number.isNaN(upperInputVal) || (upperInputVal > parseInt($upperRange.attr('max'), 10)) || (upperInputVal < parseInt($lowerRange.attr('min'), 10))) {
			upperInputVal = parseInt($upperRange.attr('max'), 10);
		}

        changeRefinementState($(this));

		priceSearch($(this), lowerInputVal, upperInputVal);
	});
};
